<template>
  <div id="app">
    <Content/>
  </div>
</template>

<script>
import Content from './components/Content.vue'

export default {
  name: 'app',
  components: {
    Content
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  background-color: #fff8dd;
}
#app {
  font-family: 'Noto Sans Japanese', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
